// Common color definitions
const colors = {
  primary: {
    blue: "#2984FF",
    lightBlue: "#467de3",
    darkBlue: "#2f6ad9",
    blue2: "#0085FF",
    blue3: "#2C85FF",
  },
  neutral: {
    white: "#FFFFFF",
    black: "#171717",
    darkGrey: "#28303C",
  },
  error: "#EA552B",
  greys: {
    grey1: "#677788",
    grey2: "#7F7B9D",
    grey3: "#34344B",
    grey4: "#565A79",
    grey5: "#80808F",
    grey6: "#9DA8BC",
  },
  dark: "#13152B",
};

export const light = {
  primary: {
    main: colors.primary.blue,
    blackFade: colors.neutral.black,
    buttonColor: colors.primary.blue,
    textColor: colors.neutral.white,
    hoverColor: colors.primary.darkBlue,
  },
  secondary: {
    main: colors.neutral.darkGrey,
    buttonColor: colors.neutral.darkGrey,
    textColor: colors.neutral.white,
    hoverColor: colors.neutral.darkGrey,
  },
  tertiary: {
    textColor: colors.primary.blue,
  },
  disabled: {
    buttonColor: "rgba(0, 0, 0, 0.12)",
    textColor: "rgba(0, 0, 0, 0.26)",
  },
  text: {
    primary: colors.primary.blue,
    primary2: colors.primary.blue2,
    secondary: colors.greys.grey1,
    light: colors.neutral.white,
    error: colors.error,
    header: colors.neutral.darkGrey,
    header2: colors.greys.grey3,
    description: colors.greys.grey2,
    description2: colors.neutral.darkGrey,
    description3: colors.greys.grey4,
    body1: colors.greys.grey5,
    radioBtn: colors.neutral.darkGrey,
    pricing: colors.dark,
    caption: colors.greys.grey6,
    primaryBlue: colors.primary.blue3,
    highlight: colors.error,
  },
  // background: {
  //   paper: colors.neutral.white,
  //   default: colors.neutral.white,
  //   level2: "#f5f5f5",
  //   level1: colors.neutral.white,
  // },
  border: {
    border1: "#C8DFFF",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  fontFamily: {
    medium: "SpaceGrotesk-Medium",
  },
};
